/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./payment-dialog.vue?vue&type=template&id=3534b23a&scoped=true&"
import script from "./payment-dialog.vue?vue&type=script&lang=js&"
export * from "./payment-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3534b23a",
  null
  
)

export default component.exports